/* eslint-disable @typescript-eslint/no-explicit-any */
import imageUrlBuilder from '@sanity/image-url'
import { createClient } from '@sanity/client'
import { isPreproduction, isProduction, sanityApiVersion, sanityDataset, sanityProjectId } from '../../env'
import { ImageUrlBuilderOptionsWithAliases } from '@sanity/image-url/lib/types/types'

export const sanity = createClient({
  projectId: sanityProjectId,
  dataset: sanityDataset,
  apiVersion: sanityApiVersion,
  token: process.env.SANITY_ACCESS_TOKEN,
  perspective: isProduction || isPreproduction ? 'published' : 'previewDrafts',
  useCdn: isProduction || isPreproduction,
})

export const buildSanityImageSrcset = (image: any, widths = [400, 800, 1200, 1600, 2400], quality = 90): string => {
  if (!sanityDataset || !sanityProjectId) return ''
  const builder = imageUrlBuilder({ dataset: sanityDataset, projectId: sanityProjectId })
  return widths
    .map(
      (w) =>
        `${builder.image(image.asset).width(w).quality(quality).sharpen(25).auto('format').fit('max').toString()} ${w}w`
    )
    .join(', ')
}

export const getProductPreviewImage = (product?: { images?: any[]; media?: any[] } | null) =>
  product?.media?.find((item) => item.type === 'image') ?? product?.images?.[0]

export const mapImage = (image: any, options?: Partial<ImageUrlBuilderOptionsWithAliases>) => {
  if (!sanityDataset || !sanityProjectId)
    throw new Error('Missing configuration for Sanity content, please check that environment variables are set')

  if (['video', 'model3d'].includes(image?.type)) return image

  return {
    ...image,
    src: imageUrlBuilder({ dataset: sanityDataset, projectId: sanityProjectId })
      .image(image.asset)
      .sharpen(25)
      .withOptions({ auto: 'format', fit: 'max', quality: 90, ...options })
      .toString(),
    alt: image.alt ?? null,
    width: image.dimensions?.width,
    height: image.dimensions?.height,
  }
}
